
	import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: {}
	})
	export default class SearchSVG extends Vue {}
